import { type Brand } from '@/consts/brands';
import { get } from '@/utils/http/client';
import { urls } from '@/utils/urls';

const runCookieMiddleware = (brand: Brand) =>
  get(urls[brand].api.guest.cookieMiddleware);

export const GuestService = {
  runCookieMiddleware,
};
